
interface GameHintProps {
    text : string
    title? : string
    className? : string
    isCorrect? : boolean
}

export function GameHint(props : GameHintProps) {
    if(!props.text) {
        return null
    }
    return <div className={"quiz-hint" + (props.className !== undefined ? " " + props.className : "")}>
        <img src="images/shared/cloud-hint.png"  alt="" />
        <div className="text">
            {props.title !== undefined &&
            <span className="correct">{props.title}</span>
            }
            {(props.title === undefined && props.isCorrect !== undefined) &&
                (props.isCorrect ? <span className="correct">Dobrze!</span> : <span className="wrong">Źle!</span>)
            }
            {props.text}
        </div>
    </div>
}